import React from 'react';
import { Helmet } from "react-helmet-async";
import { Switch, Route, Redirect } from 'react-router-dom';
import SectionHeader from '../../../../components/section-header/section-header';
import ProfilePanel from '../profile-panel/profile-panel';
import ProfileEditPanel from '../profile-edit-panel/profile-edit-panel';
import './profile-page.scss';
import ProfileEditPanelNew from '../profile-edit-panel/profile-edit-panel-new';

const ProfilePage = () => {
    return (
        <div className="profile-page">
            <SectionHeader title="Profile" />
            <Switch>
                <Route exact path="/profile">
                    <Helmet>
                        <title>TRIYO · Profile Page</title>
                    </Helmet>
                    <ProfilePanel />
                </Route>
                <Route exact path="/profile/edit">
                    <Helmet>
                        <title>TRIYO · Edit Profile Page</title>
                    </Helmet>
                    <ProfileEditPanelNew />
                </Route>
                <Route>
                    <Redirect to="/profile" />
                </Route>
            </Switch>
        </div>
    );
};

export default ProfilePage;